export default __webpack_public_path__ + "static/media/PBRSBanner.18e67ba0ba79511579cc.18e67ba0.png";